const Sms = () => (
  <svg
    width={55}
    height={54}
    viewBox="0 0 55 54"
    fill="#fff"
  >
    <path
      d="M48.8335 0.333252H6.16683C3.2335 0.333252 0.860163 2.73325 0.860163 5.66659L0.833496 53.6666L11.5002 42.9999H48.8335C51.7668 42.9999 54.1668 40.5999 54.1668 37.6666V5.66659C54.1668 2.73325 51.7668 0.333252 48.8335 0.333252ZM19.5002 24.3333H14.1668V18.9999H19.5002V24.3333ZM30.1668 24.3333H24.8335V18.9999H30.1668V24.3333ZM40.8335 24.3333H35.5002V18.9999H40.8335V24.3333Z"
    />
  </svg>
);
export default Sms;